/**
 * Component for AccountMessage
 *
 * @module components/AccountMessage
 */

import values from 'lodash/values';
import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';

import { ApiAccountMessageDismissed } from '../../../../actions/Api';
import { setIsEditingAccountInfo } from '../../../../actions/UserAccount';
import ButtonLink, { ButtonLinkStyles } from '../../../../components/ButtonLink';
import { AccountMessageBlueBars, accountMessageStrings } from '../../../../constants/BlueBar';
import QA from '../../../../constants/QATags';
import { getInfoPath } from '../../../../lib/RouteUtils';
import MiniHeader from '../../MiniHeader/MiniHeader';

import './AccountMessageBar.scss';

const blueBarIds = values(AccountMessageBlueBars);

class AccountMessageBar extends React.Component {
  static propTypes = {
    onClose: PropTypes.func,
    setIsEditingAccountInfo: PropTypes.func,
    ApiAccountMessageDismissed: PropTypes.func,
    id: PropTypes.oneOf(blueBarIds).isRequired,
  };

  getContent = () => {
    const output = {
      buttonMessage: accountMessageStrings.fixNowButton,
      buttonLink: getInfoPath(),
    };
    switch (this.props.id) {
      case AccountMessageBlueBars.INVALID_INFO_MESSAGE:
        output.mainMessage = accountMessageStrings.invalidInfoMessage;
        return output;
      case AccountMessageBlueBars.UPDATE_INFO_MESSAGE:
        output.mainMessage = accountMessageStrings.confirmInfoMessage;
        return output;
      case AccountMessageBlueBars.UPDATE_EMAIL_MESSAGE:
        output.mainMessage = accountMessageStrings.invalidEmailMessage;
        return output;
      case AccountMessageBlueBars.UPDATE_ZIP_CODE_MESSAGE:
        output.mainMessage = accountMessageStrings.outdatedZipMessage;
        return output;
      default:
        return;
    }
  };

  onLinkClick = () => {
    this.props.setIsEditingAccountInfo(true);
    this.props.ApiAccountMessageDismissed(this.props.id);
    this.props.onClose();
  };

  renderLink = () => {
    const barContents = this.getContent();
    return (
      <ButtonLink
        handleClick={this.onLinkClick}
        styleNames={[ButtonLinkStyles.NAV_BLUEBAR, ButtonLinkStyles.NAV]}
        to={barContents.buttonLink}
        title={barContents.buttonMessage}
      />
    );
  };

  render() {
    const barContents = this.getContent();

    return (
      <MiniHeader showing={true} onClose={this.props.onClose}>
        <div className='AccountMessageBar' data-qa={QA.MB}>
          <FormattedMessage {...barContents.mainMessage} />
          {!barContents.doNotShowLink && this.renderLink()}
        </div>
      </MiniHeader>
    );
  }
}

export default connect(null, {
  setIsEditingAccountInfo,
  ApiAccountMessageDismissed,
})(AccountMessageBar);
